jQuery(document).ready(function ($) {
    if (typeof $.fn.select2 === 'function') {
        const listingTabsSections = document.querySelectorAll('section.listing_tabs');

        listingTabsSections.forEach(function (section) {
            const tabsUniqueId = section.getAttribute('data-tabs-id') || section.id || 'default';

            const tabContainer = section.querySelector(`#${tabsUniqueId}-pills-tab`);
            const tabContent = section.querySelector(`#${tabsUniqueId}-pills-tabContent`);
            const mobileSelect = section.querySelector(`#${tabsUniqueId}-mobile-province-select`);

            if (!tabContainer || !tabContent || !mobileSelect) return;

            $(mobileSelect).select2({
                minimumResultsForSearch: 10,
                width: '100%',
                dropdownParent: section
            });

            // Handle mobile select change
            $(mobileSelect).on('change', function () {
                const selectedTabId = this.value;
                const targetTab = section.querySelector(`[data-bs-target="${selectedTabId}"]`);

                if (targetTab) {
                    section.querySelectorAll('.nav-link').forEach(tab => {
                        tab.classList.remove('active');
                        tab.setAttribute('aria-selected', 'false');
                    });

                    targetTab.classList.add('active');
                    targetTab.setAttribute('aria-selected', 'true');

                    section.querySelectorAll('.tab-pane').forEach(pane => {
                        pane.classList.remove('show', 'active');
                    });

                    const targetPane = section.querySelector(selectedTabId);
                    if (targetPane) {
                        targetPane.classList.add('show', 'active');
                    }
                }
            });

            // Handle tab clicks and sync with mobile select
            section.querySelectorAll('.nav-link').forEach(tab => {
                tab.addEventListener('click', function () {
                    const targetId = this.getAttribute('data-bs-target');
                    $(mobileSelect).val(targetId).trigger('change');
                });
            });
        });
    }
});